import { Content } from "@prismicio/client";
import React from "react";
import { EFixedBarPosition } from "@middleware/types";
import { URL_PAGE_BILAN } from "@middleware/constants";
import FixedBar from "../FixedBar/FixedBar";
import style from "./BilanBar.module.scss";

interface Props {
  bilanBarData?: Content.BilanBarDocument | Content.BilanBarStagingDocument;
}
export default function BilanBar({ bilanBarData }: Props) {
  return (
    bilanBarData?.data.activateOrDeactivate === true && (
      <FixedBar
        text={bilanBarData.data.text}
        button={{
          label: bilanBarData.data.buttonLabel?.toString() ?? "",
          href: URL_PAGE_BILAN,
        }}
        position={EFixedBarPosition.TOP}
        className={style.bar}
        actionClassName={style.action}
        wrapClassName={style.wrap}
      />
    )
  );
}
